module.exports = __webpack_public_path__ + "static/img/client-persona.cfaa813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client-persona.png
// module id = 552
// module chunks = 1